import axios from 'axios';
import { responderAoPainelDeOfertas } from './respostas';

export const instalarMocksDoPainelDeOfertas = () => {
    const adaptadorReal = axios.getAdapter(axios.defaults.adapter);

    axios.defaults.adapter = (configuracao) => responderAoPainelDeOfertas(configuracao) || adaptadorReal(configuracao);
};
